<template>
<div class="form">
  <v-card style="margin-top: 250px">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <h1 align="center" style="text-decoration: underline overline;">HK2 - AKTIVITI PERTANIAN</h1>

      <v-text-field
        outlined 
        dense
        rounded
        v-model="HID"
        label="HID"
        width="20px"
        disabled
      ></v-text-field>


      <!-- DATATABLE  -->
      <v-card  color="rgba(217, 217, 217, 0.5)" class="mb-5">
            <v-card-title>
                Senarai
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>

            <v-spacer></v-spacer>
                <v-btn
                color="error"
                small
                @click="dialogPengesahan=true;"
                >
                  Padam
                </v-btn>


            </v-card-title>

          
            <v-data-table
              :headers="headers"
              :items="dataHK2"
              :search="search"
              class="ml-3 mr-3"
              @click:row="handleClick"
            >
            <template v-slot:item.HK2B2= "{ item }">
            {{ formatNumber(item.HK2B2) }}
            </template>
            <template v-slot:item.HK2A1= "{ item }">
            {{ formatNumber(item.HK2A1) }}
            </template>
            <template v-slot:item.HK2A2= "{ item }">
            {{ formatNumber(item.HK2A2) }}
            </template>
            <template v-slot:item.HK2C1= "{ item }">
            {{ formatNumber(item.HK2C1) }}
            </template>
            <template v-slot:item.HK2C3= "{ item }">
            {{ formatNumber(item.HK2C3) }}
            </template>
            <template v-slot:item.HK2C4a= "{ item }">
            {{ formatNumber(item.HK2C4a) }}
            </template>
            <template v-slot:item.HK2C4b= "{ item }">
            {{ formatNumber(item.HK2C4b) }}
            </template>
            <template v-slot:item.HK2C4= "{ item }">
            {{ formatNumber(item.HK2C4) }}
            </template>
            <template v-slot:item.HK2INCS21a= "{ item }">
            {{ formatNumber(item.HK2INCS21a) }}
            </template>
            <template v-slot:item.HK2INCS21A_i= "{ item }">
            {{ formatNumber(item.HK2INCS21A_i) }}
            </template>
            <template v-slot:item.HK2INCS21A_ii= "{ item }">
            {{ formatNumber(item.HK2INCS21A_ii) }}
            </template>
            <template v-slot:item.HK2INCS21A_iii= "{ item }">
            {{ formatNumber(item.HK2INCS21A_iii) }}
            </template>
          </v-data-table>
      </v-card>   
    </v-card> 


  <v-card>
    <v-card-title>
      Pendapatan daripada bekerja sendiri (Pertanian)
    </v-card-title>

    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >

        <!-- s24 -->
        <v-row v-show="showS24">
          <v-col>
          S24 : Apakah jenis pekerjaan anda atau ahli isi rumah? <strong>[PK]</strong>
          <v-autocomplete
              :items="masco"
              :item-text="item => item.kod +' - '+ item.keterangan"
              return-object
              outlined
              dense
              v-model="HK2PK"
          ></v-autocomplete>
          </v-col>
        </v-row>

        <!-- s25 -->
        <v-row v-show="showS25">
          <v-col>
          S25 : Apakah aktiviti/hasil pengeluaran utama (industri) tempat anda bekerja? <strong>[PN]</strong>
          <v-autocomplete
              :items="msic"
              :item-text="item => item.kod +' - '+ item.keterangan"
              return-object
              outlined
              dense
              v-model="HK2PN"
          ></v-autocomplete>
          </v-col>
        </v-row>

        <!-- s26 -->
        <v-row>
          <v-col>
            S26 : Nyatakan tempoh bagi soalan S24 <strong>[M]</strong>
            <v-row>
              <!-- tempoh -->
              <v-col cols="4">
                <v-autocomplete
                    min="0"
                    maxlength="2"
                    :items="tambahlookupbulan"
                    v-model="HK2M"
                    label="Tempoh(bulan)"
                    outlined
                    dense
                    :item-text="item => item.id"
                    item-value="id"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

  <v-form ref="form2" :disabled="disabledInput"> <!-- disable input kalau month NaN/empty -->
        <!-- s38 -->
        <v-row>
          <v-col cols="4">
          S38 : Mempunyai akaun penyata kira-kira?
          <v-select
              :items="yaTidak"
              item-text="desc"
              return-object
              solo
              dense
              v-model="HK2S38"
          ></v-select>
          </v-col>
        </v-row>

  <div v-show="soalanAkaunPenyataYa">
        <!-- s39 -->
        <v-row>
          <v-col>
            S39 : Tempoh penyata kira-kira (dalam bulan)
            <v-row>
                <v-col cols="4" sm="6" md="4">
                  <v-text-field
                        v-model="HK2S39"
                        label="bulan"
                        outlined
                        type="number"
                        dense
                  ></v-text-field>
                </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- s40 -->
        <v-row v-show="showS40">
          <v-col>
            S40 : Keuntungan bersih sebagaimana tercatat dalam penyata kira-kira dalam 12 bulan yang lalu <strong>[B1]</strong>
            <v-row>
                <v-col cols="4" sm="6" md="4">
                  <v-text-field
                        v-model="HK2B1"
                        label="RM"
                        outlined
                        type="number"
                        dense
                        persistent-hint
                        hint="Setahun"
                        @keypress="limitDigits"
                        :rules="schemeRule.no7digit"
                  ></v-text-field>
                </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- s41 -->
        <v-row v-show="showS41">
          <v-col>
            S41 : Anggaran keuntungan bersih berdasarkan penyata kira-kira tahun sebelum ini dalam 12 bulan yang lalu <strong>[B2]</strong>
            <v-row>
                <v-col cols="4" sm="6" md="4">
                  <v-text-field
                        v-model="HK2B2"
                        label="RM"
                        outlined
                        type="number"
                        dense
                        persistent-hint
                        hint="Setahun"
                        @keypress="limitDigits"
                        :rules="schemeRule.no7digit"
                  ></v-text-field>
                </v-col>
            </v-row>
          </v-col>
        </v-row>
  </div>

    <div v-show="soalanAkaunPenyataTidak">
          <!-- s42 -->
          <v-row>
            <v-col>
              S42 : Nyatakan nilai penerimaan daripada jualan barang-barang keluaran dalam 12 bulan yang lalu <strong>[A1]</strong>
              <v-row>
                  <v-col cols="4" sm="6" md="4">
                    <v-text-field
                          v-model="HK2A1"
                          label="RM"
                          outlined
                          type="number"
                          dense
                          persistent-hint
                          hint="Setahun"
                          @keypress="limitDigits"
                          :rules="schemeRule.no7digit"
                    ></v-text-field>
                  </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- s43 -->
          <v-row>
            <v-col>
              S43 : Jumlah perbelanjaan dalam 12 bulan yang lalu <strong>[A2]</strong>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-alert-circle
                    </v-icon>
                  </template>
                  <span>Termasuk sewa tanah pertanian/peralatan; gaji dan upah yang dibayar untuk membajak, menanam, mengubah, merumput, memungut hasil, 
                    menoreh, mengangkut, cukai tanah dan cukai lain; bayaran tali air, pembaikan dan penyelenggaraan dan perbelanjaan lain seperti kos baja, 
                    racun serangga, racun rumpai, racun kulat, insurans, menternak. merawat dan mengawal penyakit, menyelenggara infrastruktur (cth: parit/jalan), 
                    menyelenggara tempat/peralatan ternakan benih/bunga/pokok, membersih tanah dll. (cth: kandang), menanam benih/bunga/pokok, membersih tanah dll.
                  </span>
                </v-tooltip>
              <v-row>
                  <v-col cols="4" sm="6" md="4">
                    <v-text-field
                          v-model="HK2A2"
                          label="RM"
                          outlined
                          type="number"
                          dense
                          persistent-hint
                          hint="Setahun"
                          @keypress="limitDigits"
                          :rules="schemeRule.no7digit"
                    ></v-text-field>
                  </v-col>
              </v-row>
            </v-col>
          </v-row>
    </div>

      <!-- s44 -->
      <v-row>
        <v-col>
          S44 : Pendapatan bersih <strong>[C1]</strong>
          <v-row>
              <v-col cols="4" sm="6" md="4">
                <v-text-field
                      v-model="HK2C1"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      persistent-hint
                      hint="Setahun"
                      disabled
                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s45 -->
      <v-row>
        <v-col> 
          S45 : Peratus pembahagian di C1 yang dipegang oleh ahli isi rumah <strong>[C2]</strong>
          <v-row>
              <v-col cols="2" sm="6" md="4">
                <v-text-field
                      v-model="HK2C2"
                      label="%"
                      outlined
                      type="number"
                      dense
                      :rules="[rules.percentage,rules.takmauPoint]"
                ></v-text-field>
              </v-col>
          </v-row>
        </v-col> 
      </v-row>

      <!-- s46 -->
      <v-row>
        <v-col>
          S46 : Nilai mutlak bagi C2 <strong>[C3]</strong>
          <v-row>
              <v-col cols="4" sm="6" md="4">
                <v-text-field
                      v-model="HK2C3"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      persistent-hint
                      hint="Setahun"
                      @keypress="limitDigits"
                      :rules="schemeRule.no7digit"
                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s47-->
      <v-row>
        <v-col>
          S47 : Anggaran hasil pertanian dan penternakan yang diambil dalam 12 bulan yang lalu untuk:
          <v-row class="mt-2">
            <v-col cols="4" sm="4" md="4">
              a) Kegunaan isi rumah <strong>[C4a]</strong>
              <v-text-field
                    v-model="HK2C4a"
                    label="RM"
                    outlined
                    type="number"
                    hint="Setahun"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>

            <v-col cols="4" sm="4" md="4">
              b) Lain-lain (seperti zakat, biji benih, pemberian, dll) <strong>[C4b]</strong>
              <v-text-field
                    v-model="HK2C4b"
                    label="RM"
                    outlined
                    type="number"
                    hint="Setahun"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>

            <v-col cols="4" sm="4" md="4">
              Jumlah <strong>[C4]</strong>
              <v-text-field
                    v-model="HK2C4"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    disabled
                    hint="Setahun"
                    persistent-hint
                    @change="kiraINCS01()"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s48 -->
      <v-row>
        <v-col>
          S48 : Pendapatan bersih yang diterima oleh isi rumah <strong>[C5]</strong>
          <v-row>
              <v-col cols="4" sm="6" md="4">
                <v-text-field
                      v-model="HK2INCS21a"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      persistent-hint
                      hint="Setahun"
                      @keypress="limitDigits"
                      :rules="schemeRule.no7digit"
                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s49-->
      <v-row>
        <v-col>
          S49 : Pendapatan daripada C5 :
          <v-row class="mt-2">
            <v-col cols="4" sm="4" md="4">
              i) Pendapatan berkaitan pertanian dan penternakan dalam talian melalui transaksi e-dagang (cth: menerima pesanan melalui tiktok shop, facebook, lazada, shopee, laman web khusus, dll) <strong>[INCS21A(i)]</strong>
             </v-col>
            <v-col cols="4" sm="4" md="4"><br><br>
              <v-text-field
                    v-model="HK2INCS21A_i"
                    label="RM"
                    outlined
                    type="number"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>
      </v-row>
      <v-row>
            <v-col cols="4" sm="4" md="4">
              ii) Pendapatan berkaitan pertanian dan penternakan dalam talian melalui transaksi bukan e-dagang (cth: menerima pesanan melalui whatsapp, emel, dll) <strong>[INCS21A(ii)]</strong> 
             </v-col>
            <v-col cols="4" sm="4" md="4"><br><br>
              <v-text-field
                    v-model="HK2INCS21A_ii"
                    label="RM"
                    outlined
                    type="number"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4" sm="4" md="4">
              iii) Pendapatan berkaitan pertanian dan penternakan bukan dalam talian <strong>[INCS21A(iii)]</strong><br><br>
              </v-col>
            <v-col cols="4" sm="4" md="4"><br><br>
              <v-text-field
                    v-model="HK2INCS21A_iii"
                    label="RM"
                    outlined
                    type="number"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no7digit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s37 -->
      <v-row>
        <v-col cols="4" sm="4" md="4">
        S37 : Adakah anda atau ahli isi rumah mempunyai pekerjaan lain dalam tempoh 12 bulan yang lalu? <strong>[KL]</strong>
        <v-select
            :items="yaTidak"
            item-text="desc"
            return-object
            solo
            dense
            v-model="HK2KL"
        ></v-select>
        </v-col>
      </v-row>

    </v-form>


    </v-form>
  </v-card-text>

 
<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        :disabled="butangSimpan"
    >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="updateHK2()"
    >
      Kemaskini
    </v-btn>
     <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="goTo('1')"
    >
      Seterusnya
    </v-btn>
</v-card-actions>
</v-card>

 <v-alert
  prominent
  type="error"
  :value="popUpALert"
 >
  <v-row align="center" class="mb-2">
    <v-col class="grow">
      Adakah anda pasti untuk padam?
    </v-col>
    <v-col class="shrink">
      <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
      <v-btn @click="padam('2')">Cancel</v-btn>
    </v-col>
  </v-row>
</v-alert>
  

<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      max-width="800"
      height="200"
    >
    <v-card
      color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>

      <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              Batal
            </v-btn>
            <!-- <v-btn
                color="primary"
                @click='goTo("1")'
            >
              Ke Ringkasan Isi Rumah
            </v-btn> -->
            <v-btn
              color="primary"
              @click='goTo("1")'
            >
              Pengisian Seterusnya
            </v-btn>
      </v-card-actions>
    </v-card>
</v-dialog>

<!-- Kemaskini Dialog -->
<v-dialog
      v-model="kemaskiniDialog"
      max-width="800"
      height="200"
    >
    <v-card
    >
      <v-alert
        dense
        solo
      >
      <strong>Data Dipilih, Sila Mulakan Pengemaskinian</strong>
      </v-alert>
    </v-card>
</v-dialog>


<!-- Pengesahan Padam Dialog -->
 <v-row justify="center">
    <v-dialog
      v-model="dialogPengesahan"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
         <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="dialogPengesahan = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padamData()"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>


</div>
</template>
<script>
import axios from '../../plugins/axios'
import schemeRule from '../../utils/scheme'
//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

import hidServices from "@/services/lookupField";
const lookup = new hidServices();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
    //props:['data'],
    async beforeMount(){
        
        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;
        //dapatkan data based on HID

        this.masco = await lookupFieldServices.getMasco(); //dapatkan lookup masco
        this.msic = await lookupFieldServices.getMsic(); //dapatkan lookup msic
        this.yaTidak = lookupFieldServices.getYaTidak();

        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;

        this.getData();
    },
    data: () => ({
       
        butangSimpan: true,
        butangKemaskini: false,
        disabledInput : true,
        showS24: true,
        showS25: true,
        showS40 : false,
        showS41 : false,
        dialog: false,
        kemaskiniDialog: false,
        successDialog: false,
        dialogPengesahan: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        search: '',
        currNOAIRData:'',
        masco:[],
        msic:[],
        yaTidak:[],
        selectedData: [],
        soalanAkaunPenyataYa:false,
        soalanAkaunPenyataTidak:false,
        
        
        /////////////////////data declaration//////////////////////////
        
        HK2PK:'',
        HK2PN:'',
        HK2M:"",
        HK2S38 : '{"id":"0","desc":"Sila Pilih"}',
        HK2S39:0,
        HK2B1:0,
        HK2B2:0,
        HK2A1:0,
        HK2A2:0,
        HK2C1:0,
        HK2C2:0,
        HK2C3:0,
        HK2C4a:0,
        HK2C4b:0,
        HK2C4:0,
        HK2INCS21a:0,
        HK221A_i:0,
        HK221A_ii:0,
        HK221A_iii:0,
        HK2INCS21A_i: 0,
        HK2INCS21A_ii: 0,
        HK2INCS21A_iii: 0,
        HK2KL:'',
        NOAIR:'',
        Bil:'',
        KAW: '',
        Bulan:'',
        Tahun:'',
        BNO:'',
        Ps:'',
        S:'',
        NG: '',
        DP:'',
        DB:'',
        BP:'',
        ST:'',
        NOTK:'',
        NOIR:'',
        R:'',
        dataHK2: [],
        headers: [
          {
            text: 'NOAIR',
            align: 'start',
            sortable: false,
            value: 'NOAIR',
          },
          { text: 'PK', value: 'HK2PK' },
          { text: 'PN', value: 'HK2PN' },
          { text: 'M', value: 'HK2M' },
          { text: 'S38', value: 'HK2S38' },
          { text: 'S39', value: 'HK2S39' },
          { text: 'B1', value: 'HK2B1' },
          { text: 'B2', value: 'HK2B2' },
          { text: 'A1', value: 'HK2A1' },
          { text: 'A2', value: 'HK2A2' },
          { text: 'C1', value: 'HK2C1' },
          { text: 'C2', value: 'HK2C2' },
          { text: 'C3', value: 'HK2C3' },
          { text: 'C4a', value: 'HK2C4a' },
          { text: 'C4b', value: 'HK2C4b' },
          { text: 'C4', value: 'HK2C4' },
          { text: 'C5', value: 'HK2INCS21a' },
          { text: 'INCS21A(i)', value: 'HK2INCS21A_i' },
          { text: 'INCS21A(ii)', value: 'HK2INCS21A_ii' },
          { text: 'INCS21A(iii)', value: 'HK2INCS21A_iii' },
          { text: 'KL', value: 'HK2KL' },
        ],
       ///////////link untuk ke page/////////////////////
      breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        {
          text: 'HK2',
          disabled: true,
          href: 'hk2',
        },
      ],
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      rules: {
        required: v => !!v || 'field is required',
        emel: (value) => {
          return /.+@.+\..+/.test(value) || 'E-mail must be valid'
        },
        percentage:(value)=>{
          return (value <= 100) || 'Percentage must between 1 - 100'
        },
        takmauPoint:(value)=>{
          return (value % 1 === 0)? true:'No point needed'
        }
          
        },
      select: null,
      checkbox: false,
    }),

    methods: {
      formatNumber(value) {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      stripCommas(value) {
        return value.replace(/,/g, '');
      },
      validate () {
        this.$refs.form.validate()
      },
      limitDigits(event) {
        const value = event.target.value;
        if (value.length >= 7) {
            event.preventDefault();
        }
      },
      reset() {
        this.$refs.form.reset();
        this.$refs.form2.reset();
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      async simpan (){

        if (this.$refs.form.validate()){
            this.dialog =  true;
            setTimeout(() => (this.dialog = false), 2000)
         
            try {
	
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/HK2`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                HK2PK: this.HK2PK.kod,
                HK2PN:  this.HK2PN.kod,
                P:  this.Ps,
                HK2M:  this.HK2M,
                HK2S38:  this.HK2S38.id,
                HK2S39 : this.HK2S39,
                HK2B1 : this.HK2B1,
                HK2B2 : this.HK2B2,
                HK2A1 : this.HK2A1,
                HK2A2 : this.HK2A2,
                HK2C1 : this.HK2C1,
                HK2C2 : this.HK2C2,
                HK2C3 : this.HK2C3,
                HK2C4a : this.HK2C4a,
                HK2C4b : this.HK2C4b,
                HK2C4 : this.HK2C4,
                HK2INCS21a : this.HK2INCS21a,//kena calculate total
                HK221A_i : this.HK221A_i,
                HK2INCS21A_i : this.HK2INCS21A_i,//kena calculate total
                HK221A_ii : this.HK221A_ii,
                HK2INCS21A_ii : this.HK2INCS21A_ii,//kena calculate total
                HK221A_iii : this.HK221A_iii,
                HK2INCS21A_iii : this.HK2INCS21A_iii,//kena calculate total
                HK2KL : this.HK2KL.id,
                 //////////total yang perlu diupdate ke jr5///////////
                totalHK2INCS21a : this.totalHK2INCS21a,
                totalHK2INCS21A_i : this.totalHK2INCS21A_i,
                totalHK2INCS21A_ii : this.totalHK2INCS21A_ii,
                totalHK2INCS21A_iii : this.totalHK2INCS21A_iii,
              })
                this.res = res.data;
                this.reset();
                this.getData();
                this.successMessage = 'Data Disimpan!';
                this.successDialog = true;
                window.scrollTo(0, 0);
                this.butangSimpan = true;
                
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
        }else{
          window.scrollTo(0, 0);
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'Please fill in the field!';
        }
      },
      async updateHK2(){
            try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/updateHK2`, {
                
                HID:  this.HID,
                NOAIR: this.NOAIR,
                P: this.Ps,
                HK2PK: this.HK2PK,
                HK2PN:  this.HK2PN,
                HK2M:  this.HK2M,
                HK2S38:  this.HK2S38.id,
                HK2S39 : this.HK2S39,
                HK2B1 : this.HK2B1,
                HK2B2 : this.HK2B2,
                HK2A1 : this.HK2A1,
                HK2A2 : this.HK2A2,
                HK2C1 : this.HK2C1,
                HK2C2 : this.HK2C2,
                HK2C3 : this.HK2C3,
                HK2C4a : this.HK2C4a,
                HK2C4b : this.HK2C4b,
                HK2C4 : this.HK2C4,
                HK2INCS21a : this.HK2INCS21a,
                HK221A_i : this.HK221A_i,
                HK2INCS21A_i : this.HK2INCS21A_i,
                HK221A_ii : this.HK221A_ii,
                HK2INCS21A_ii : this.HK2INCS21A_ii,
                HK221A_iii : this.HK221A_iii,
                HK2INCS21A_iii : this.HK2INCS21A_iii,
                HK2KL : this.HK2KL.id,

                //////////total yang perlu diupdate ke jr5///////////
                totalHK2INCS21a : this.totalHK2INCS21a,
                totalHK2INCS21A_i : this.totalHK2INCS21A_i,
                totalHK2INCS21A_ii : this.totalHK2INCS21A_ii,
                totalHK2INCS21A_iii : this.totalHK2INCS21A_iii,
              })
                this.res = res.data;
                this.reset();
                this.getData();
                this.butangKemaskini = false;
                this.successMessage = 'Data Dikemaskini!';
                this.successDialog = true;
                window.scrollTo(0, 0);
                this.butangSimpan = false;
            } catch (error) {
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
      },
   async padamData(){
        try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                table: "HK2"
              })
                this.res = res.data;
                this.reset();
                this.dialogPengesahan = false;
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 1000);
                this.successMessage = 'Data Dipadam!'
                this.getData(); 
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }  
      },
      async getData(){
        //dapatkan data dari table HK1 based on HID
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/HK/HK2?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
            })
            //this.dataHK2 = res.data.data;
            var dataz = res.data.data
            this.dataHK2 = dataz;
            console.log(this.dataHK2)

          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
      },
      handleClick(row) {
          this.selectedData = [];
          this.selectedData = row;
          this.kemaskiniDialog = true;
          setTimeout(() => (this.kemaskiniDialog = false), 1000);

          this.showS24 = false;
          this.showS25 = false;
          this.butangSimpan = false;
          this.butangKemaskini = true;

          this.NOAIR = row.NOAIR;
          this.Bil = row.Bil;
          this.HK2PK = row.HK2PK;
          this.HK2PN = row.HK2PN;
          this.HK2M = row.HK2M;
          this.HK2S38 = row.HK2S38;
          this.HK2S39 = row.HK2S39;
          this.HK2B1 = row.HK2B1;
          this.HK2B2 = this.stripCommas(row.HK2B2);
          this.HK2A1 = this.stripCommas(row.HK2A1);
          this.HK2A2 = this.stripCommas(row.HK2A2);
          this.HK2C1 = this.stripCommas(row.HK2C1);
          this.HK2C2 = row.HK2C2;
          this.HK2C3 = this.stripCommas(row.HK2C3);
          this.HK2C4a = this.stripCommas(row.HK2C4a);
          this.HK2C4b = this.stripCommas(row.HK2C4b);
          this.HK2C4 = this.stripCommas(row.HK2C4);
          this.HK2INCS21a = this.stripCommas(row.HK2INCS21a);
          this.HK2INCS21A_i = this.stripCommas(row.HK2INCS21A_i);
          this.HK2INCS21A_ii = this.stripCommas(row.HK2INCS21A_ii);
          this.HK2INCS21A_iii = this.stripCommas(row.HK2INCS21A_iii);




          
          //this.HK2B2 = row.HK2B2;
          //this.HK2A1 = row.HK2A1;
          //this.HK2A2 = row.HK2A2;
          //this.HK2C1 = row.HK2C1;
          //this.HK2C2 = row.HK2C2;
          //this.HK2C3 = row.HK2C3;
          //this.HK2C4a = row.HK2C4a;
          //this.HK2C4b = row.HK2C4b;
          //this.HK2C4 = row.HK2C4;
          //this.HK2INCS21a = row.HK2INCS21a;
          // this.HK221A_i = row.HK221A_i;
          // this.HK221A_ii = row.HK221A_ii;
          // this.HK221A_iii = row.HK221A_iii;
          // this.HK2INCS21A_i = row.HK2INCS21A_i;
          // this.HK2INCS21A_ii = row.HK2INCS21A_ii;
          // this.HK2INCS21A_iii = row.HK2INCS21A_iii;
          

          //console.log(this.HK2INCS21A_iii)
          //this.HK2KL = row.HK2KL;

          if(row.HK2S38 == 1){
            this.HK2S38 = this.yaTidak[0];
          }
          if(row.HK2S38 == 2){
            this.HK2S38 = this.yaTidak[1];
          }
          //----------------------------------------
          if(row.HK2KL == 1){
            this.HK2KL = this.yaTidak[0];
          }
          if(row.HK2KL == 2){
            this.HK2KL = this.yaTidak[1];
          }
      },
      kiraHK2C3(){
        var total = 0;
        total = Number(this.HK2C1) * Number(this.HK2C2) 
        this.HK2C3 = total;
      },
      kiraHK221A(){
        var total = 0;
        total = Number(this.HK2C3) + Number(this.HK2C4) 
        this.HK221A = total;
      },
      kiraINCS19(){
        var total = 0;
        total = Number(this.INCS19a) + Number(this.INCS19b) + Number(this.INCS19c)
        this.INCS19 = total;
      },
      goTo(option){

        if(option == "1"){
          this.$router.push({name: "ringkasanMaklumatIR"});
        }

        if(option == "2"){
      
          if(this.HK2KL.id == "1"){
            this.$router.push({name: "JRB"});
          }
          if(this.HK2KL.id == "2"){
            this.$router.push({name: "ringkasanMaklumatIR"});
          }
         
        }   
      }
    },
    watch:{
      HK2S38(val){
        var valueS38 = val.id;
        if(valueS38 == 1){
          //setkan value s42,s43 jadi 0
          this.HK2A1 = 0;
          this.HK2A2 = 0;
          this.soalanAkaunPenyataYa = true;
          this.soalanAkaunPenyataTidak = false;
        }
        if(valueS38 == 2){
          //setkan soalan s39,s40,s41 jadi 0
          this.HK2S39 = 0;
          this.HK2B1 = 0;
          this.HK2B2 = 0;
          this.soalanAkaunPenyataYa = false;
          this.soalanAkaunPenyataTidak = true;
        }

      },
      HK2S39(){
        if(this.HK2S39 >=6){
          this.showS40 = true;
          this.showS41 = false;
          this.HK2B2 = 0;
        }else{
          this.showS40 = false;
          this.showS41 = true;
          this.HK2B1 = 0;
        }
      },
      HK2B2(){
        this.HK2C1 = this.HK2B2;
      },
      HK2B1(){
        this.HK2C1 = this.HK2B1;
      },
      //tukar guna computed
      HK2A2(){
        this.HK2C1 = Number(this.HK2A1) - Number(this.HK2A2);
      },
      //tukar guna computed
      HK2C4a(){
        this.HK2C4 = Number(this.HK2C4a) + Number(this.HK2C4b);
      },
      //tukar guna computed
      HK2C4b(){
        this.HK2C4 = Number(this.HK2C4a) + Number(this.HK2C4b);
      },
      //tukar guna computed
      HK2C2(){
        this.HK2C3 = Number(this.HK2C1) * Number(this.HK2C2)/100;
      },
      //tukar guna computed
      HK2C4(){
        this.HK2INCS21a = Number(this.HK2C3) + Number(this.HK2C4);
      },
      //tukar guna computed
      HK221A_i(){ 
        this.HK2INCS21A_i = Number(this.HK221A_i) * Number(this.HK2INCS21a)/100;
      },
      //tukar guna computed
      HK221A_ii(){
        this.HK221A_iii = Number(this.HK221A_i) + Number(this.HK221A_ii); 
        this.HK221A_iii = 100 - Number(this.HK221A_iii);

        this.HK2INCS21A_ii = Number(this.HK221A_ii) * Number(this.HK2INCS21a)/100;
      },
      //tukar guna computed
      HK221A_iii(){
        this.HK2INCS21A_iii = Number(this.HK221A_iii) * Number(this.HK2INCS21a)/100;
      },
      HK2M(val){
    
        if(isNaN(val)){
            this.disabledInput = true;
          }else{
            this.disabledInput = false;
        }
      },
      HK2PK(val){
        let found = this.dataHK2.some(ele => ele.HK2PK === val.kod);
        if(found == true){
          this.HK2PK = [];
          this.errorDialog = true;
          this.errMessage = 'Pekerjaan Sudah Wujud dan telah diisi! Sila Pilih Pekerjaan Lain';
          setTimeout(() => (this.errorDialog = false), 2000);
        }
      },
      HK2INCS21A_i(val){
        if(isNaN(val)){
            this.butangSimpan = true;
          }else{
            this.butangSimpan = false;
        }
      },
    },
    computed:{
      Msebenar: function(){
          var d1 = new Date(this.dateMula);
          var d2 = new Date(this.dateTamat);
          
          var months = 0;
          months = (d2.getFullYear() - d1.getFullYear()) * 12;
         months -= d1.getMonth();
          months += d2.getMonth()+1;

          return months;
      },
      tambahlookupbulan() {
      return lookup.getBulan();
      },
      totalHK2INCS21a:  function(){
          var total = 0;
          if(this.dataHK2.length >= 1){
            ///calculate semua value HK2INCS21a yang telah di insert
            for(var i = 0; i < this.dataHK2.length ; i++){
              total = total + Number(this.dataHK2[i].HK2INCS21a)
            }
          }
          ///tambahkan total yang telah diinsert dengan current HK2INCS21a yang bakal diinsert
          //total = total + Number(this.HK2INCS21a) - Number(this.selectedData.HK2INCS21a);
          if(this.selectedData.HK2INCS21a){
              total = total + Number(this.HK2INCS21a) - Number(this.selectedData.HK2INCS21a);
          }else{
              total = total + Number(this.HK2INCS21a) ;
          }
          return total;
      }, 
      totalHK2INCS21A_i:  function(){

          var total = 0;
          if(this.dataHK2.length >= 1){
            ///calculate semua value HK2INCS21A_i yang telah di insert
            for(var i = 0; i < this.dataHK2.length ; i++){
              total = total + Number(this.dataHK2[i].HK2INCS21A_i)
            }
          }

          ///tambahkan total yang telah diinsert dengan current HK2INCS21A_i yang bakal diinsert
          //total = total + Number(this.HK2INCS21A_i) - Number(this.selectedData.HK2INCS21A_i);
          if(this.selectedData.HK2INCS21A_i){
              total = total + Number(this.HK2INCS21A_i) - Number(this.selectedData.HK2INCS21A_i);
          }else{
              total = total + Number(this.HK2INCS21A_i) ;
          }
          return total;

      }, 
      totalHK2INCS21A_ii:  function(){
          var total = 0;
          if(this.dataHK2.length >= 1){
            ///calculate semua value HK2INCS21A_ii yang telah di insert
            for(var i = 0; i < this.dataHK2.length ; i++){
              total = total + Number(this.dataHK2[i].HK2INCS21A_ii)
            }
          }

          ///tambahkan total yang telah diinsert dengan current HK2INCS21A_ii yang bakal diinsert
          //total = total + Number(this.HK2INCS21A_ii) - Number(this.selectedData.HK2INCS21A_ii);
          if(this.selectedData.HK2INCS21A_ii){
              total = total + Number(this.HK2INCS21A_ii) - Number(this.selectedData.HK2INCS21A_ii);
          }else{
              total = total + Number(this.HK2INCS21A_ii) ;
          }
          return total
      }, 
      totalHK2INCS21A_iii:  function(){
         var total = 0;
         if(this.dataHK2.length >= 1){
          ///calculate semua value HK2INCS21A_iii yang telah di insert
          for(var i = 0; i < this.dataHK2.length ; i++){
            total = total + Number(this.dataHK2[i].HK2INCS21A_iii)
          }
         }
          ///tambahkan total yang telah diinsert dengan current HK2INCS21A_iii yang bakal diinsert
          //total = total + Number(this.HK2INCS21A_iii) - Number(this.selectedData.HK2INCS21A_iii);
          if(this.selectedData.HK2INCS21A_iii){
              total = total + Number(this.HK2INCS21A_iii) - Number(this.selectedData.HK2INCS21A_iii);
          }else{
              total = total + Number(this.HK2INCS21A_iii) ;
          }
          return total
      }, 
      schemeRule() {
      return schemeRule;
    },
    }
}
</script>

<style>
#app {
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}

</style>